import * as React from 'react';
import debounce from 'lodash.debounce';
import animateScrollTo from 'animated-scroll-to';

import './BackToTop.scss';

export function BackToTop() {
  const buttonRef = React.useRef<HTMLButtonElement | null>(null);

  React.useEffect(() => {
    const shownBackToTopClassName = 'back-to-top--shown';

    const handleScroll = debounce((event: Event) => {
      const documentElement = (event.target as Document).documentElement;
      if (documentElement.scrollTop >= 2000) {
        buttonRef.current?.classList.add(shownBackToTopClassName);
      } else {
        buttonRef.current?.classList.remove(shownBackToTopClassName);
      }
    }, 200);

    document.addEventListener('scroll', handleScroll);
    return () => document.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClickButton = React.useCallback(() => void animateScrollTo(0), []);

  return (
    <button className="back-to-top" ref={buttonRef} onClick={handleClickButton}>
      <div className="back-to-top__icon" />
    </button>
  );
}
